import { MessageTransactionMessagePreference } from '@quorum/models/xs-resource';

export function normalizePhone(phone: string): string {
  return (phone || '').replace(/\D/g, '');
}

export function isValidPhone(phone: string): boolean {
  return normalizePhone(phone).length === 10;
}

export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email || '');
}

export function isMessagePreferenceOverrideFormValid(override: MessageTransactionMessagePreference): boolean {
  if (!override.messagePreferenceId) return false;
  const contact = (override.messagePreferenceContactInfo ?? '').trim();
  if (!contact) return false;
  if (override.messagePreferenceId === 1) return isValidEmail(contact);
  if (override.messagePreferenceId === 2) return isValidPhone(contact);
  return false;
}

export function getMessagePreferenceContactInfoError(override: MessageTransactionMessagePreference): string | null {
  const contact = (override.messagePreferenceContactInfo ?? '').trim();
  const hasRealPhoneDigits = override.messagePreferenceId === 2 && !!normalizePhone(contact);
  const effectivelyEmpty = !contact || (override.messagePreferenceId === 2 && !hasRealPhoneDigits);

  if (effectivelyEmpty) return null;
  if (override.messagePreferenceId === 1) {
    return isValidEmail(contact) ? null : 'Please enter a valid email address.';
  }
  if (override.messagePreferenceId === 2) {
    return isValidPhone(contact) ? null : 'Please enter a valid 10-digit phone number (e.g. 403-123-4567).';
  }
  return null;
}
